import { Profile } from "../Auth/ProfileModel";

export class DeveloperProfileResponse {
    constructor(){
      this.id = 0;
    }
   public id: number;
   public profile: Profile = new Profile();
  }